import axios from 'axios';
import { generateQueryParams } from 'utils/generateQueryParams';

export const EmployeesService = {
  // TODO change api
  async getEmployeeFullNameByIIN(IIN) {
    const res = await axios.get(`/api/checkIIN?iin=${IIN}`);

    if (res.status === 200) {
      return res.data;
    }
    return Promise.reject();
  },

  async getAllEmployeesOfClient(clientId) {
    const res = await axios.get(`org/v1/workers/select/all/${clientId}/`);

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },

  async getEmployees(page, perPage, filters, tribe_id) {
    const params = generateQueryParams({
      page,
      size: perPage,
      ...filters,
      tribe_id: tribe_id === 3 ? null : tribe_id,
    });

    const res = await axios.get(`org/v1/workers/clients/`, {
      params,
    });

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },

  async createEmployeeOfClient(payload) {
    const res = await axios.post('org/v1/workers/', payload);

    if (res.status === 201) {
      return true;
    }

    return Promise.reject();
  },

  async updateEmployeeOfClient(payload, workerId) {
    const res = await axios.put(`org/v1/workers/${workerId}/`, payload);

    if (res.status === 200) {
      return true;
    }

    return Promise.reject();
  },

  async deleteEmployeeOfClient(workerId) {
    const res = await axios.delete(`org/v1/workers/${workerId}/`);

    if (res.status === 200) {
      return true;
    }

    return Promise.reject();
  },

  async getEmployeesRecords(page, perPage, filters, tribe_id) {
    const params = generateQueryParams({
      page,
      size: perPage,
      ...filters,
      tribe_id: tribe_id === 3 ? null : tribe_id,
    });

    const res = await axios.get('org/v1/records/client/', {
      params,
    });

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },

  async createEmployeeRecord(payload) {
    const res = await axios.post('org/v1/records/multipleworker/', payload);

    if (res.status === 201) {
      return true;
    }

    return Promise.reject();
  },

  async updateEmployeeRecord(payload, recordId) {
    const res = await axios.put(`org/v1/records/${recordId}/`, payload);

    if (res.status === 200) {
      return true;
    }

    return Promise.reject();
  },

  async deleteEmployeeRecord(recordId) {
    const res = await axios.delete(`org/v1/records/${recordId}/`);

    if (res.status === 200) {
      return true;
    }

    return Promise.reject();
  },

  async fetchVacationDays(employeeId, dismissalDate) {
    const res = await axios.get(
      `org/v1/clients/worker/vacation-days-to-compensate/${employeeId}/?begin_date=${dismissalDate}`
    );

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },
};
